module.exports = __webpack_public_path__ + "static/img/Illustration_4_OPS.ec6dac72.svg";